import React from 'react';
import {
  ImageRelatedContentPropsDto,
  RelatedContentDto
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { getRelatedContentImageUrl } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.utilities';
import {
  getImageChunkProps
} from './ai-chat.utilities';
import { ELSIcon } from '@els/els-component-form-field-react';
import { ELSTokenHelper } from '@els/els-ui-common-react';

export type RelatedContentImageProps = {
  relatedContent: RelatedContentDto;
  onClick?: (relatedContent: RelatedContentDto) => void;
}

export const RelatedContentImageComponent = (props: RelatedContentImageProps): JSX.Element => {
  const { relatedContent, onClick } = props;

  const handleClick = () => {
    if (onClick) {
      onClick(relatedContent);
    }
  };

  // Extract chunk properties from the new structure
  const imageProps = relatedContent.contentProps as ImageRelatedContentPropsDto;
  const chunkProps = getImageChunkProps(imageProps);
  const token = ELSTokenHelper.getToken();

  const imageUrl = getRelatedContentImageUrl(relatedContent.id, token);
  const altText = chunkProps?.description || relatedContent.title || 'Related image';
  const caption = chunkProps?.caption;

  return (
    <button
      className="u-els-debuttonize c-els-related-content-image"
      onClick={handleClick}
    >
      <div className="c-els-related-content-image__wrapper">
        <div
          role="img"
          aria-label={altText}
          className="c-els-related-content-image__image"
          style={{
            backgroundImage: `url(${imageUrl})`
          }}
        />
        <div className="c-els-related-content-image__link-icon-wrapper">
          <ELSIcon
            prefix="gizmo"
            name="expand"
            size="1x1o2"
            customClass="c-els-related-content-image__link-icon"
          />
        </div>
      </div>
      {caption && (
        <div
          title={caption}
          className="c-els-related-content-image__caption"
        >
          {caption}
        </div>
      )}
    </button>
  );
};

const RelatedContentImage = RelatedContentImageComponent;
export default RelatedContentImage;
